export default __webpack_public_path__ + "static/char-s-17-cht-5ec48574cf080692560739277c046be3.webp";